import React from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';

function Contact() {
  return (
    <Box id="contact" my={6}>
      <Typography variant="h4" align="center" gutterBottom>
        Contact Us
      </Typography>
      <Box component="form" action="https://formspree.io/f/mdkgaerg" method="POST" maxWidth="sm" mx="auto">
        <TextField name="name" label="Name" fullWidth margin="normal" required />
        <TextField name="email" label="Email" type="email" fullWidth margin="normal" required />
        <TextField name="message" label="Message" multiline rows={4} fullWidth margin="normal" required />
        <Box textAlign="center" mt={2}>
          <Button type="submit" variant="contained" color="primary">
            Send Message
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Contact;
